var map = {
	"./Formular-Black.woff2": 279,
	"./Formular-BlackItalic.woff2": 280,
	"./Formular-Bold.woff2": 281,
	"./Formular-BoldItalic.woff2": 282,
	"./Formular-Italic.woff2": 283,
	"./Formular-Light.woff2": 284,
	"./Formular-LightItalic.woff2": 285,
	"./Formular-Medium.woff2": 286,
	"./Formular-MediumItalic.woff2": 287,
	"./Formular.woff2": 288
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 278;


//////////////////
// WEBPACK FOOTER
// ./src/fonts ^\.\/.*\.woff2$
// module id = 278
// module chunks = 0